<template lang="pug">
Popup(:visible="visible" @close="handleClose")
  .exchange-success-popup-container
    img.exchange-success-popup-close(src="https://m.hellobike.com/38477a9af8.png" @click="handleClose")
    .exchange-success-goods(:v-if="goodsInfo.image")
      SafeImg(:class="'exchange-success-goods-img'" :src='goodsInfo.image')

    .exchange-success-title-container
      .exchange-success-title 恭喜获得
      .exchange-success-title-desc 商品已发放至您的账户

    .exchange-success-btn-container
      .exchange-success-btn(@click="handleShowInfoClick") 查看
</template>

<script>
import { Popup } from '@hb/platformui-h5';
import SafeImg from '@/components/safe-img.vue';


export default {
  name: 'ExchangeSuccessPopup',
  components: {
    Popup,
    SafeImg,
  },
  props: {
    // 是否显示弹窗
    visible: {
      type: Boolean,
      default: true,
    },
    // 商品信息
    goodsInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: ['isSupportAd'],
  methods: {
    // 关闭弹窗
    handleClose() {
      this.$emit('close');
    },

    // 查看商品信息点击
    handleShowInfoClick() {
      this.$emit('showInfoClick');
    },
  },
};
</script>

<style scoped lang="less">
.exchange-success-popup-container {
  background: linear-gradient(180deg, #fff8d7 0%, #fff 47.57%, #fff 47.57%);
  display: flex;
  padding: 0.1rem;
  position: relative;
  border-radius: 0.2rem;
  flex-direction: column;
  min-width: 2.7rem;

  .exchange-success-popup-close {
    position: absolute;
    width: 0.32rem;
    height: 0.32rem;
    left: 50%;
    bottom: -0.62rem;
    transform: translateX(-50%);
  }

  .exchange-success-goods {
    position: absolute;
    top: -0.435rem;
    border-radius: 0.12rem;
    overflow: hidden;
    left: 50%;
    transform: translateX(-50%);

    .exchange-success-goods-img {
      width: 1.12rem;
      height: 0.72rem;
    }
  }

  .exchange-success-title-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0.4rem;

    .exchange-success-title {
      height: 0.28rem;
      line-height: 0.28rem;
      font-size: 0.2rem;
      font-weight: 600;
      color: #373b3e;
    }

    .exchange-success-title-desc {
      height: 0.22rem;
      line-height: 0.22rem;
      font-size: 0.16rem;
      font-weight: 400;
      color: #373b3e;
      margin-top: 0.02rem;
    }
  }

  .exchange-success-btn-container {
    margin-top: 0.3rem;
    display: flex;
    padding: 0 0.16rem 0.16rem;
    justify-content: center;

    .exchange-success-btn {
      height: 0.4rem;
      border: 0.01rem solid #ff5526;
      min-width: 0.92rem;
      font-size: 0.14rem;
      color: #ff5526;
      border-radius: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      position: relative;
      margin-right: 0.08rem;
      padding: 0 0.225rem;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .exchange-success-ad-container {
    min-height: 0.66rem;
  }
}
</style>
